import { create } from 'zustand';

export interface PatientContext {
  cdPaciente: number;
  cdAtendimento?: number | null;
  clinicalEncounterId?: string | null;
  nome: string;
  status?: string | null;
  meta?: string | null;
}

interface PatientContextState {
  patient: PatientContext | null;
  setPatient: (patient: PatientContext) => void;
  clearPatient: () => void;
}

export const usePatientContextStore = create<PatientContextState>((set) => ({
  patient: null,
  setPatient: (patient) =>
    set((state) => ({
      patient:
        state.patient?.cdPaciente === patient.cdPaciente
          ? {
              ...state.patient,
              ...patient,
              clinicalEncounterId:
                patient.clinicalEncounterId ?? state.patient.clinicalEncounterId ?? null,
            }
          : patient,
    })),
  clearPatient: () => set({ patient: null }),
}));
